import React, { Fragment } from 'react';
import banners, { BannerTypes } from '@gin-betting/banners';

import { Carousel, Spinner, PromoItem } from 'components';
import favorite from 'modules/favorite';
import { AsyncOddButton } from 'modules/betslip/async';
import useEventsOfTheDay from './useEventsOfTheDay';
import './eventsOfTheDay.scss';

const {
    components: { ToggleFavoriteButton },
} = favorite;

const {
    hocs: { withAvailableZoneByAttributes },
} = banners;

const EventsOfTheDay: React.FC<BannerTypes.WithAvailableZoneProps> = ({
    zoneId,
}) => {
    const { items, isLoadTimeUp } = useEventsOfTheDay(zoneId);

    if (!items.length) {
        return !isLoadTimeUp ? (
            <div styleName="spinner">
                <Spinner />
            </div>
        ) : null;
    }

    return (
        <div styleName="container">
            <Carousel direction="left" delay={10000} hasControls={true}>
                {items.map(({ id: matchId, type }) => {
                    if (!matchId) return null;

                    return (
                        <Fragment key={`${type}-${matchId}`}>
                            <PromoItem
                                matchId={matchId}
                                type={type}
                                favoriteButton={
                                    <ToggleFavoriteButton matchId={matchId} />
                                }
                                AsyncOddButton={AsyncOddButton}
                            />
                        </Fragment>
                    );
                })}
            </Carousel>
        </div>
    );
};

export default withAvailableZoneByAttributes(EventsOfTheDay);
